// Configuration Firebase pour CETROBON - KILA France
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Configuration Firebase réelle
const firebaseConfig = {
  apiKey: "AIzaSyDZ4TmKGdyV2lWoskG2wmSj9kHsOk8eGvo",
  authDomain: "cetrobon-f31f2.firebaseapp.com",
  projectId: "cetrobon-f31f2",
  storageBucket: "cetrobon-f31f2.firebasestorage.app",
  messagingSenderId: "975580093471",
  appId: "1:975580093471:web:e97c56b17ab1eae934c92a",
  measurementId: "G-BJ8KRXP8QB"
};

// Initialisation Firebase
let app;
let auth;
let db;
let storage;

try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  
  console.log('🔥 Firebase initialisé avec succès - Projet réel:', firebaseConfig.projectId);
} catch (error) {
  console.error('❌ Erreur initialisation Firebase:', error);
}

export { auth, db, storage };
export default app;